import { Badge } from '../../components/ui/badge';
import { Alert, AlertDescription } from '../../components/ui/alert';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from '../../components/ui/card';
import { formatDateTime } from '../../utils/dateFormat';

export interface SimInventorySearchResult {
  simInventory: {
    iccid: string;
    status: string;
    allocatedAt: string | null;
    partnerName: string | null;
    partnerCode: string | null;
    hasLinkedCustomer: false;
  };
  tenant: { mvno: string; displayName?: string };
}

export function SimInventoryResult({
  result,
}: {
  result: SimInventorySearchResult;
}) {
  const { simInventory: sim, tenant } = result;
  return (
    <Card>
      <CardHeader>
        <CardTitle>SIM inventory details</CardTitle>
        <CardDescription>No customer account linked</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <Alert>
          <AlertDescription>
            This SIM exists in the tenant inventory, but has no linked customer
            account.
          </AlertDescription>
        </Alert>
        <dl className="grid gap-4 sm:grid-cols-2">
          <div>
            <dt>ICCID</dt>
            <dd>{sim.iccid}</dd>
          </div>
          <div>
            <dt>Tenant</dt>
            <dd>{tenant.displayName || tenant.mvno}</dd>
          </div>
          <div>
            <dt>SIM status</dt>
            <dd>
              <Badge variant="secondary">{sim.status}</Badge>
            </dd>
          </div>
          <div>
            <dt>Allocated at</dt>
            <dd>
              {sim.allocatedAt
                ? formatDateTime(sim.allocatedAt)
                : 'Not recorded'}
            </dd>
          </div>
          <div>
            <dt>Allocated partner</dt>
            <dd>{sim.partnerName || 'Not recorded'}</dd>
          </div>
          <div>
            <dt>Partner code</dt>
            <dd>{sim.partnerCode || 'Not recorded'}</dd>
          </div>
        </dl>
      </CardContent>
    </Card>
  );
}
